

































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import vSelect from "vue-select";
import FolderTree from "@/components/common/folders/FolderTree.vue";
import BackgroundInfoModal from "@/components/backgrounds/modals/BackgroundInfoModal.vue";
import BackgroundDeleteModal from "@/components/backgrounds/modals/BackgroundDeleteModal.vue";
import BackgroundPreviewModal from "@/components/backgrounds/modals/BackgroundPreviewModal.vue";
// service methods
import { getFilteredBackgrounds, copyBackground } from "@/services/backgrounds/backgroundService";
import { getAllTemplates } from "@/services/templates/templateService";
import { getAllChannels } from "@/services/channels/channelsService";
// types
import { Background, BackgroundsFilterDtoIn } from "@/services/backgrounds/types";
import { Folder, FolderEntites } from "@/services/folders/types";
import { Option } from "@/services/common/types";
import { backgroundsFields } from "@/components/backgrounds/fields/backgroundsFields";

@Component({
    components: {
        vSelect,
        "folder-tree": FolderTree,
        "background-info-modal": BackgroundInfoModal,
        "background-delete-modal": BackgroundDeleteModal,
        "background-preview-modal": BackgroundPreviewModal
    }
})
export default class Backgrounds extends Vue {
    // local state
    backgrounds = [] as Array<Background>;
    fields = backgroundsFields;
    isBusy = false;
    sortBy = "name";
    sortDesc = false;

    // folders
    folderEntity = FolderEntites.Backgrounds;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;

    // filter
    selectedTemplate = null as Option | any;
    selectedChannel = null as Option | any;
    filterWidth = "" as string;
    filterHeight = "" as string;

    // filter options
    templates = [] as Array<Option>;
    channels = [] as Array<Option>;
    searchText = "" as string;

    // lifecycle hooks
    public created(): void {
        this.fetchData();
        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // methods & actions
    setBackgroundFolderId(data: { entityId: string, folderId: string }) {
        this.backgrounds.forEach((background) => {
            if (background.id === data.entityId) background.folderId = data.folderId;
        });
    }

    selectFolder(folder: Folder) {
        this.selectedFolderNode = folder;
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
        }
    }

    deleteBackground(backgroundId: string, name: string) {
        (this.$refs.backgroundDeleteModal as any).open(backgroundId, name);
    }

    backgroundInfo(backgroundId: string) {
        (this.$refs.backgorundInfoModal as any).open(backgroundId);
    }

    updateBackgroundRoute(backgroundId: string) {
        return {
            name: "updatebackground",
            params: { backgroundId: backgroundId }
        };
    }

    previewBackground(backgroundId: string, name: string) {
        (this.$refs.backgroundPreviewModal as any).open(backgroundId, name);
    }

    fetchData() {
        this.loadBackgrounds();
        getAllTemplates().then(response => {
            this.templates = response.map(x => ({
                id: x.id,
                text: x.name
            }));
        });
        getAllChannels().then(response => {
            this.channels = response.map(x => ({
                id: x.id,
                text: x.name
            }));
        });
    }

    loadBackgrounds() {
        this.isBusy = true;
        this.backgrounds = [] as Array<Background>;
        getFilteredBackgrounds({
            templateId: this.selectedTemplate ? this.selectedTemplate.id : "",
            channelId: this.selectedChannel ? this.selectedChannel.id : ""
        } as BackgroundsFilterDtoIn).then(response => {
            this.backgrounds = response;
            this.isBusy = false;
        });
    }

    clearFilter() {
        this.selectedTemplate = null;
        this.selectedChannel = null;
        this.filterWidth = "";
        this.filterHeight = "";
        this.loadBackgrounds();
    }

    copyBackground(id: string) {
        copyBackground(id).then(() => this.loadBackgrounds());
    }

    // computed and watchers
    get model(): Array<Background> {
        if (this.filterActive) {
            return this.backgrounds.filter(
                x => (this.searchText === "" ? true : x.name.toLowerCase().includes(this.searchText.toLowerCase())) &&
                    (this.filterWidth === "" ? true : x.width === +this.filterWidth) &&
                    (this.filterHeight === "" ? true : x.height === +this.filterHeight)
            );
        } else {
            return this.backgrounds.filter(
                x => this.selectedFolderNode.id ? x.folderId === this.selectedFolderNode.id : true
            );
        }
    }

    get filterActive(): boolean {
        return (
            (this.selectedTemplate && Object.keys(this.selectedTemplate.id).length > 0) ||
            (this.selectedChannel && Object.keys(this.selectedChannel.id).length > 0) ||
            this.searchText !== "" ||
            this.filterWidth !== "" ||
            this.filterHeight !== "");
    }

    get addBackground() {
        return {
            name: "createbackground",
            params: { folderId: this.selectedFolderNode.id }
        };
    }

    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        this.showFolderTree = !value;
    }

    // drag events
    drag(event: any) {
        event.dataTransfer.setDragImage(this.$refs["element_" + event.target.getAttribute("entityId")] as any, -10, 0);
        event.dataTransfer.setData(
            "type",
            event.target.getAttribute("type")
        );
        event.dataTransfer.setData(
            "folderEntity",
            event.target.getAttribute("folderEntity")
        );
        event.dataTransfer.setData(
            "entityId",
            event.target.getAttribute("entityId")
        );
    }
}
